import type {
  BaseQueryFn,
  TypedUseMutation,
  TypedUseQuery,
} from "@reduxjs/toolkit/query/react";

import { injectBillingEndpoints } from "../../../../core/store/reduxApi/billing";
import type {
  CreatePortalSessionRequest,
  CreatePortalSessionResponse,
  PlanSummaryResponse,
  PreviewInvoiceRequest,
  PreviewInvoiceResponse,
  UpdateSubscriptionRequest,
  UpdateSubscriptionResponse,
} from "../../../../core/store/reduxApi/billing";
import { reduxApiSlice } from "./index";

export type {
  BillingInterval,
  CreatePortalSessionRequest,
  CreatePortalSessionResponse,
  PlanSummaryResponse,
  PreviewInvoiceRequest,
  PreviewInvoiceResponse,
  UpdateSubscriptionRequest,
  UpdateSubscriptionResponse,
} from "../../../../core/store/reduxApi/billing";

const extendedApi = injectBillingEndpoints(reduxApiSlice);

export const useGetPlanSummaryQuery =
  extendedApi.useGetPlanSummaryQuery as TypedUseQuery<
    PlanSummaryResponse,
    void,
    BaseQueryFn
  >;
export const useUpdateSubscriptionMutation =
  extendedApi.useUpdateSubscriptionMutation as TypedUseMutation<
    UpdateSubscriptionResponse,
    UpdateSubscriptionRequest,
    BaseQueryFn
  >;
export const useCreatePortalSessionMutation =
  extendedApi.useCreatePortalSessionMutation as TypedUseMutation<
    CreatePortalSessionResponse,
    CreatePortalSessionRequest,
    BaseQueryFn
  >;
export const usePreviewInvoiceMutation =
  extendedApi.usePreviewInvoiceMutation as TypedUseMutation<
    PreviewInvoiceResponse,
    PreviewInvoiceRequest,
    BaseQueryFn
  >;
